angular.module('CarsSaraBo').factory('ReviewGAConfig', ['GAService', function (gaService) {
	return {
		reviewGa: function () {
			const EVENT_CATEGORY = "Autos_comentarios";
			const PAGE_VIEW = "Page view";
			const HOW_IT_WORKS = "Como funciona";
            const ERASE_FILTERS = "Borrar filtros";
			const CLICKS = "Clicks";

			var mapInfo = {
				"Page_view": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [PAGE_VIEW])
				},
				"Como_funciona": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [HOW_IT_WORKS])
				},
				"Filtros_usados": function (eventName, param) {
					gaService.notify(EVENT_CATEGORY, eventName, [filterSelected(param)])
				},
				"Valores_de_filtros": function (eventName, param) {
					gaService.notify(EVENT_CATEGORY, eventName, [filterValues(param)])
				},
				"Borrar_filtros": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [ERASE_FILTERS])
				},
				"Ordenar": function (eventName, param) {
					gaService.notify(EVENT_CATEGORY, eventName, [sortString(param)])
				},
				"Ir_a_pagina": function (eventName, param) {
					gaService.notify(EVENT_CATEGORY, eventName, [param.currentPage, param.currentPage+1])
				},
                "Click_ID": function (eventName, param) {
                    gaService.notify(EVENT_CATEGORY, eventName, [param])
                },
				"Exportar": function (eventName, param) {
                    gaService.notify(EVENT_CATEGORY, eventName, [param]);
                }				,
				"Enviar_respuesta_comentario": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [CLICKS]);
				},
				"Cancelar_respuesta_comentario": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [CLICKS]);
				}
			};
			return {
				send: function (eventName, param1) {
					mapInfo[eventName].call(mapInfo, eventName, param1);
				}
			}

			function filterValues(param){
				var filters = "";
				if(param.destination != ""){
					filters=filters.concat("Lugar de devolucion: "+ param.destination.name);
				}
				if(param.evaluation != ""){
					if( filters != ""){
						filters=filters.concat(", ")
					}
					filters = filters.concat("Puntaje: "+param.evaluation);
				}
				if(param.dateRange != undefined && param.dateRange.from != undefined && param.dateRange.to != undefined){
					if( filters != ""){
						filters=filters.concat(", ")
					}
					filters=filters.concat("Fecha del comentario: "+param.dateRange.from+" - "+param.dateRange.to);
				}
				return filters;
			}

			function filterSelected(param){
				var filters = "";
				if(param.destination != ""){
					filters=filters.concat("Lugar de devolucion");
				}
				if(param.evaluation != ""){
					if( filters != ""){
						filters=filters.concat(", ")
					}
					filters = filters.concat("Puntaje");
				}
				if(param.dateRange != undefined && param.dateRange.from != undefined && param.dateRange.from != undefined){
					if( filters != ""){
						filters=filters.concat(", ")
					}
					filters=filters.concat("Fecha del comentario");
				}
				return filters;
			}

			function sortString(sorting){
				if(sorting === "OVERALL_RATING_ASC"){
					return "Puntaje: Menor";
				} else if(sorting === "OVERALL_RATING_DESC"){
					return "Puntaje: Mayor";
				} else if(sorting === "REVIEW_DATE_DESC"){
					return "Fecha del comentario: Descendente";
				}
			}
		}
	}
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/review_ga_config_service.js
// module id = 863
// module chunks = 3